interface SurveyBorderCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  className?: string
}

/**
 * Checkbox toggling the survey-grade U.S. land-border overlay (IBWC + IBC).
 * Shared between the Explore Layers panel (below the group radios) and the
 * homepage's standalone bottom-left box, so both read identically. The blue
 * accent matches the border line drawn on the map.
 */
export function SurveyBorderCheckbox({ checked, onChange, className }: SurveyBorderCheckboxProps) {
  return (
    <label
      className={[
        'flex items-center gap-2 cursor-pointer text-[13px]',
        'text-[var(--color-text)] hover:text-[var(--color-accent)] transition-colors',
        className ?? '',
      ].join(' ')}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="w-3.5 h-3.5 accent-[#2f7dff] cursor-pointer"
      />
      <span className="font-medium">United States border</span>
      <span aria-hidden className="text-[13px] leading-none">
        🇺🇸
      </span>
    </label>
  )
}
